module.exports = __webpack_public_path__ + "img/camera-retro.3c3e50cf.svg";